import { useMemo } from "react";
import { avatarBgs } from "./const";
import { getFormatSpeakerName } from "./util";
import VoiceCardAvatarIcon from "@/assets/common/ic_voice_card_avatar.svg?react";

interface SpeakerAvatarProps {
  avatarIndex?: number;
  speakerName: string;
  className?: string;
  size?: "big";
  useDefaultAvatarIcon?: boolean;
  fontSize?: string;
}

const SpeakerAvatar: React.FC<SpeakerAvatarProps> = ({
  avatarIndex,
  speakerName,
  className,
  size,
  useDefaultAvatarIcon = false,
  fontSize,
}) => {
  const formatSpeakerName = getFormatSpeakerName(speakerName || '');
  const bg = useMemo(
    () => (avatarIndex !== undefined ? avatarBgs[avatarIndex%avatarBgs.length] : undefined),
    [avatarIndex]
  );

  return (
    <div
      className={`${className} rounded-[50%] overflow-hidden font-500 text-#fff flex items-center justify-center ${(size === 'big'? "text-1.25rem" : formatSpeakerName.length === 1 ? "text-1rem" : "text-0.75rem")}`}
      style={{
        background: bg,
        fontSize: fontSize,
      }}
    >
      {formatSpeakerName && !useDefaultAvatarIcon ? (
        formatSpeakerName
      ) : (
        <VoiceCardAvatarIcon className="w-50% h-50%" />
      )}
    </div>
  );
};

export default SpeakerAvatar;
